 import cx from 'classnames';
import React, { Component } from 'react';
import { FilterImageCheckbox } from '../filterImageCheckbox/FilterImageCheckbox';
import type { CarType } from '../../types/index';
import './CheckboxGrid.scss';
export type FilterOption = {
    '@id'?: string;
    carTypes?: CarType[];
    model?: string;
    slug?: string;
    count?: number;
    key?: string | number;
    imageUrl?: string;
    title?: string;
};

type CheckboxGridProps = {
    alwaysEnabled?: boolean;
    selectedOptions: FilterOption['key'][];
    className?: string;
    fixedValues?: FilterOption[];
    gridKey: string;
    onChange: (gridKey: string, selectedOptions: FilterOption['key'][]) => void;
    optionKey?: string;
    options: FilterOption[];
    withHint?: boolean;
    labelTransformer?: (option: FilterOption) => string;
    isLeftAligned?: boolean;
};

type CheckboxGridState = {
    options: FilterOption[] | [];
};

export class CheckboxGrid extends Component<
    CheckboxGridProps,
    CheckboxGridState
> {
    constructor(props) {
        super(props);

        this.state = {
            options: []
        };
    }

    componentDidMount() {
        this.setState({
            options: this.props.options
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.options !== this.props.options) {
            this.setState({
                options: this.props.options
            });
        }
    }

    handleSelection = (label: string | number) => {
        const { selectedOptions, gridKey } = this.props;

        const nextSelectedOptions = [...selectedOptions];

        if (selectedOptions.includes(label)) {
            const index = selectedOptions.indexOf(label);
            nextSelectedOptions.splice(index, 1);
        } else {
            nextSelectedOptions.push(label);
        }
        this.props.onChange(gridKey, nextSelectedOptions);
    };

    render() {
        if (this.props.fixedValues) {
            return (
                <div className="awc-checkbox-grid checkbox-grid">
                    {this.props.fixedValues.map(option => {
                        const { optionKey } = this.props;

                        if (optionKey) {
                            const label = this.props.labelTransformer
                                ? this.props.labelTransformer(option[optionKey])
                                : option[optionKey];

                            const checked = this.props.selectedOptions.includes(
                                option[optionKey]
                            );

                            let currentElement: FilterOption | null = null;

                            for (
                                let i = 0;
                                i < this.props.options.length;
                                i++
                            ) {
                                if (
                                    this.props.options[i]?.key &&
                                    typeof this.props.options[i].key ===
                                        'string' &&
                                    // @ts-ignore
                                    this.props.options[i].key?.toLowerCase() ===
                                        option[optionKey].toLowerCase()
                                ) {
                                    currentElement = this.props.options[i];
                                }
                            }

                            return (
                                <FilterImageCheckbox
                                    alwaysEnabled={this.props.alwaysEnabled}
                                    check={checked}
                                    disabled={
                                        currentElement?.count === 0
                                    }
                                    hint={
                                        currentElement == null
                                            ? 0
                                            : String(currentElement.count)
                                    }
                                    key={option[optionKey] + option.imageUrl}
                                    label={label}
                                    onCheck={this.handleSelection}
                                    src={option.imageUrl}
                                    value={option[optionKey]}
                                />
                            );
                        }
                        return null;
                    })}
                </div>
            );
        }

        return (
            <div className={cx('awc-checkbox-grid', 'checkbox-grid', this.props.className)}>
                {this.state.options.map((option: FilterOption) => {
                    const label = this.props.labelTransformer
                        ? this.props.labelTransformer(option)
                        : option.key;
                    const checked =
                        this.props.selectedOptions?.includes(option.key) ??
                        false;

                    return (
                        <FilterImageCheckbox
                            value={option.key}
                            key={option.key + String(option.count || '')}
                            hint={String(option.count)}
                            label={label as string}
                            src={option.imageUrl}
                            check={checked}
                            onCheck={this.handleSelection}
                            disabled={option.count === 0}
                            isLeftAligned={this.props.isLeftAligned}
                        />
                    );
                })}
            </div>
        );
    }
}
